// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";
import { SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import type { DataSecurityGeneralSettings } from "@modules/service/reducer/system-access/types";

type Props = {
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  schema: Object | null,
  uiSchema: Object | null,
  formData: DataSecurityGeneralSettings,
  title: string,
  submitButtonIcon?: string,
  submitButtonText?: string,
  ...PropsFromLocalize,
};

export class SystemAccessMainOptionsModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    if (formData.ipRestrictionWhitelist) {
      const ipRestrictionList = Object.values(formData.ipRestrictionWhitelist);
      this.props.onSubmit({
        ...formData,
        ipRestrictionWhitelist: ipRestrictionList,
      });
    } else {
      this.props.onSubmit(formData);
    }
  };

  get schema() {
    if (
      this.props.schema &&
      this.props.schema.properties &&
      this.props.schema.properties.passwordResetFrequencyEmployee
    ) {
      return {
        ...this.props.schema,
        properties: {
          ...(this.props.schema || {}).properties,
          passwordResetFrequencyEmployee: {
            ...((this.props.schema || {}).properties || {}).passwordResetFrequencyEmployee,
            minimum: 1,
          },
          passwordResetFrequencyManager: {
            ...((this.props.schema || {}).properties || {}).passwordResetFrequencyManager,
            minimum: 1,
          },
        },
      };
    }

    return this.props.schema;
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader
          toggle={this.props.onDismissHandler}
          className="d-flex justify-content-between"
        >
          {this.props.title}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            formData={this.props.formData}
            schema={this.schema}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema(this.props.t)}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon={this.props.submitButtonIcon} onClick={this.submitForm}>
            {this.props.submitButtonText ? this.props.submitButtonText : this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(SystemAccessMainOptionsModal);
